/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type RestartShutdownRequest = {
  agentId: string;
};

/** @internal */
export type RestartShutdownRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const RestartShutdownRequest$outboundSchema: z.ZodType<
  RestartShutdownRequest$Outbound,
  z.ZodTypeDef,
  RestartShutdownRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function restartShutdownRequestToJSON(
  restartShutdownRequest: RestartShutdownRequest,
): string {
  return JSON.stringify(
    RestartShutdownRequest$outboundSchema.parse(restartShutdownRequest),
  );
}
